<ion-modal class="app-update-modal" [isOpen]="appUpdate.updateReady()" [canDismiss]="false" [backdropDismiss]="false">
  <ng-template>
    <div class="app-update-panel" role="alertdialog" aria-modal="true">
      <div class="app-update-brand">
        <re-app-brand-logo variant="icon" />
      </div>
      <h2 class="app-update-title">{{ 'common.appUpdateTitle' | translate }}</h2>
      <div class="app-update-divider" aria-hidden="true"></div>
      <p class="app-update-message">{{ 'common.appUpdateMessage' | translate }}</p>

      <ion-button class="app-update-action" expand="block" (click)="appUpdate.applyUpdate()"
        [disabled]="appUpdate.applying()">
        @if (appUpdate.applying()) {
        {{ 'common.loading' | translate }}
        } @else {
        {{ 'common.appUpdateBtn' | translate }}
        }
      </ion-button>
    </div>
  </ng-template>
</ion-modal>